import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { HelplistService } from 'app/helplist.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { SelectionModel } from '@angular/cdk/collections';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { BillingserviceService } from 'app/billing/billingService.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-package-selection',
  templateUrl: './package-selection.component.html',
  styleUrls: ['./package-selection.component.scss']
})
export class PackageSelectionComponent implements OnInit {
  destroypackage$: Subject<boolean> = new Subject<boolean>();
  private todaysdate = this.authService.getServerDate;
  private displayedColumns: string[] = ['packageCode','packageName', 'packageType','packageAmount'];
  private dataSource = new MatTableDataSource<any>();
  private selection = new SelectionModel<any>(true, []);
  private SelectedServiceArray: any = [];

  constructor(private dialog: MatDialog,
    private authService: AuthService,
    private dashboardService: DashboardService, private ipdService: IPDService,
    private dialogRef: MatDialogRef<PackageSelectionComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private opdvisitService: OpdVisitService) { }


  ngOnInit(): void {
    this.SelectedServiceArray=[];
    this.ipdService.selectedServiceRow = null;
    let id = this.data.id;
    let Type = this.data.Type;
    let date = this.dashboardService.selecteddate;
    this.getPackageList(Type, id, date);
  }
  ngOnDestroy() {
    this.destroypackage$.next(true);
    this.destroypackage$.unsubscribe();
    this.displayedColumns=null;
    this.todaysdate=null;
    this.selection=null;
    this.dataSource=null;
  }
  getPackageList(a, b, c) {
   this.ipdService.GetpackageList(a, b, c).pipe(takeUntil(this.destroypackage$)).subscribe(data => {
      this.dataSource.data = data;
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  applyFilter_grid(filterValue) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data?.forEach(row => this.selection.select(row));
  }
  selectRow(row) {
    this.selection.toggle(row);
    let checkarraydata = this.SelectedServiceArray.filter(item => item.pK_PackageId == row.pK_PackageId);
    if (checkarraydata.length > 0) {
      this.SelectedServiceArray = this.SelectedServiceArray.filter(item => item.pK_PackageId != row.pK_PackageId);
    } else {
      this.SelectedServiceArray.push(row);
    }

    this.SelectedServiceArray = this.SelectedServiceArray.reduce((unique, o) => {
      if (!unique.some(obj => obj.packageName === o.packageName && obj.pK_PackageId === o.pK_PackageId)) {
        unique.push(o);
      }
      return unique;
    }, []);
  }

  removeRow(x) {
    const index: number = this.SelectedServiceArray.indexOf(x);
    if (index !== -1) {
      this.SelectedServiceArray.splice(index, 1);
      this.selection.toggle(x);
    }
  }

  saveServices() {
    this.ipdService.selectedServiceRow = this.SelectedServiceArray;
    this.dialogRef.close();
  }
  closedialog() {
    this.dialogRef.close();
    this.SelectedServiceArray = [];
  }

  getrowdata(row: any) {
    this.SelectedServiceArray.push(row);
    this.ipdService.selectedServiceRow = this.SelectedServiceArray;
    this.dialogRef.close();
  }

}
